import React, { useEffect, useState } from "react";

const DataCard = ({ data, currency }) => {
  const [imageUrl, setImageUrl] = useState(
    "https://app.notifyfrance.fr/img/OTHER-light.png"
  );

  const formatWeight = (weight) => {
    const number = parseFloat(weight);
    return number % 1 === 0
      ? `${number}${currency}`
      : `${number.toFixed(2)}${currency}`;
  };

  useEffect(() => {
    const fetchImage = async () => {
      if (data.category === "SNEAKERS" && !data.image) {
        if (
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
          setImageUrl("https://app.notifyfrance.fr/img/OTHER-dark.png");
        } else {
          setImageUrl("https://app.notifyfrance.fr/img/OTHER-light.png");
        }
      } else {
        setImageUrl(data.image);
      }
    };

    fetchImage();
  }, [data.image, data.sku, data.category]);

  return (
    <div className="data-card">
      {(data.wts || data.quantity > 1) && (
        <h5>
          {data.wts && formatWeight(data.wts)}
          {data.quantity > 1
            ? ` x${data.quantity}`
            : !data.wts && data.quantity === 1
            ? `1`
            : ""}
        </h5>
      )}

      <div className="img">
        <img
          src={
            data.image !== null && data.image !== undefined
              ? data.image
              : data.category === "SNEAKERS"
              ? imageUrl
              : data.category === "BILLETERIE"
              ? window.matchMedia &&
                window.matchMedia("(prefers-color-scheme: dark)").matches
                ? "https://app.notifyfrance.fr/img/billet-dark.png"
                : "https://app.notifyfrance.fr/img/billet-light.png"
              : data.category === "VETEMENTS"
              ? window.matchMedia &&
                window.matchMedia("(prefers-color-scheme: dark)").matches
                ? `https://app.notifyfrance.fr/img/${data.articlevetement}-dark.png`
                : `https://app.notifyfrance.fr/img/${data.articlevetement}-light.png`
              : data.category === "OBJETS"
              ? imageUrl
                ? imageUrl
                : window.matchMedia &&
                  window.matchMedia("(prefers-color-scheme: dark)").matches
                ? `https://app.notifyfrance.fr/img/${data.articleobject}-dark.png`
                : `https://app.notifyfrance.fr/img/${data.articleobject}-light.png`
              : "https://app.notifyfrance.fr/img/OTHER-light.png"
          }
          alt="Data"
          onError={(e) => {
            const isDarkMode =
              window.matchMedia &&
              window.matchMedia("(prefers-color-scheme: dark)").matches;
            e.target.src = isDarkMode
              ? "https://app.notifyfrance.fr/img/OTHER-dark.png"
              : "https://app.notifyfrance.fr/img/OTHER-light.png";
          }}
        />
      </div>

      {data.category === "SNEAKERS" && <h4>{data.sku}</h4>}
      {data.category === "VETEMENTS" && <h4>{data.articlevetement}</h4>}
      <h3>{data.title}</h3>
      {(data.category === "SNEAKERS" || data.category === "VETEMENTS") && (
        <p>{data.size}</p>
      )}
      {data.category === "OBJETS" && <p>{data.articleobject}</p>}
      {data.category === "BILLETERIE" && <p>{data.dateevent}</p>}
      {data.category === "POKEMON" && <p>{data.article}</p>}
    </div>
  );
};

export default DataCard;
